module.exports = __webpack_public_path__ + "static/images/spike-jjks.3b1303a.png";